<div class="av-pg">
    <span fxLayout="column" fxLayoutGap="0px">
      <egret-search-input-over *ngIf="layoutConf.isMobile && searchClicked" placeholder="" resultPage="/search"></egret-search-input-over>
      <ng-content></ng-content>
    </span>
</div>
